// TODO (lyrics) move process lyrics to back
export function processLyrics(songToProcess) {
  const arrayLyricsSimple = [];
  let row = -1;

  songToProcess.divisions.forEach((division) => {
    if (division.newRb) {
      row = row + 1;
      arrayLyricsSimple[row] = {};
      arrayLyricsSimple[row].content = [];
      arrayLyricsSimple[row].size = 0;
    }

    let object = {};
    let lyric = '';
    let currentPrint = null;
    if (division.textDisplay.handprintNameOnChange.bloc !== '') {
      currentPrint = {
        name: division.textDisplay.handprintNameOnChange.bloc,
        id: division.handprintBlocId,
      };
    }
    if (division.textDisplay.lyrics !== '') {
      if (division.textDisplay.lyrics === '-' || division.textDisplay.lyrics === '-#') {
        lyric = '';
      }
      else {
        lyric = division.textDisplay.lyrics.replace('#', '');
      }
      division.textDisplay.lyrics = division.textDisplay.lyrics.replace('#', '');
    }
    else {
      lyric = '';
    }

    if (currentPrint != null) {
      object = {
        lyric: lyric,
        originalLyric: division.textDisplay.lyrics,
        printName: currentPrint.name,
        printIndex: currentPrint.id,
        // printIndex: currentPrint.index,
        // endDivision: currentPrint.end + songToProcess.divisionPerBeat * 4,
        globalDivision: division.id,
      };
      arrayLyricsSimple[row].content.push(object);
    }
    else {
      object = {
        lyric: lyric,
        originalLyric: division.textDisplay.lyrics,
        globalDivision: division.id,
      };
      arrayLyricsSimple[row].content.push(object);
    }
  });

  songToProcess.processedLyricsSimple = arrayLyricsSimple;

  // More complex extraction, reconstructing the full words

  row = 0;
  const arrayLyrics = [];
  arrayLyrics[row] = {};
  arrayLyrics[row].content = [];
  arrayLyrics[row].size = 0;
  let countLyrics = 0;

  // We check if the lyrics contains at least one #

  let lyricscontainshash = false;
  // eslint-disable-next-line no-unused-vars

  const mappedDivisions = songToProcess.divisions.map((division) => division.textDisplay.lyrics);
  mappedDivisions.forEach((lyricDivision) => {
    if (lyricDivision.includes('#')) {
      lyricscontainshash = true;
    }
  });

  const newLyrics = JSON.parse(JSON.stringify(songToProcess.processedLyricsSimple));
  newLyrics.forEach((lyricRow) => {
    let lyric = '';

    lyricRow.content.forEach((div, indexDiv) => {
      if (countLyrics === 0 && div.lyric !== '') {
        row = row + 1;
        arrayLyrics[row] = {};
        arrayLyrics[row].content = [];
        arrayLyrics[row].size = 0;
        countLyrics = 1;
      }

      if (indexDiv === 0) {
        lyric = div.originalLyric.charAt(0).toUpperCase() + div.originalLyric.slice(1);
        div.lyric = lyric;
        div.originalLyric = lyric;
      }

      arrayLyrics[row].content.push(div);

      if (div.originalLyric.includes('#') && lyricscontainshash) {
        row = row + 1;
        arrayLyrics[row] = {};
        arrayLyrics[row].content = [];
        arrayLyrics[row].size = 0;
      }
    });

    if (!lyricscontainshash) {
      row = row + 1;
      arrayLyrics[row] = {};
      arrayLyrics[row].content = [];
      arrayLyrics[row].size = 0;
    }
  });

  arrayLyrics.forEach(function (row) {
    let previousWord;
    // console.log(previousword);
    let lastWordDiv = 0;
    for (let i = 0; i < row.content.length; i += 1) {
      // console.log(row.content[i].lyric);
      if (row.content[i].originalLyric !== undefined && row.content[i].originalLyric.length > 0) {
        row.content[i].duration = 1;
        if (row.content[i].originalLyric.includes('-') && row.content[i].originalLyric.length >= 1) {
          if (lastWordDiv > 0) {
            lastWordDiv = i - 1;
          }
          else {
            lastWordDiv = 0;
          }
          row.content[lastWordDiv].duration += 1;

          if (i > 0) {
            previousWord = row.content[i - 1].lyric + row.content[i].originalLyric.replace('-', '').replace('#', '');
          }
          else {
            previousWord = '';
            // console.log(previousword);
          }

          let concatenateWord = previousWord;
          row.content[i].lyric = undefined;
          // console.log("initiateloop");
          for (let z = i + 1; z < row.content.length; z += 1) {
            // console.log(row.content[z].lyric);
            if (row.content[z].originalLyric === undefined) {
              // console.log("break, no lyric");
              break;
            }
            else if (row.content[z].originalLyric.includes('-')) {
              // console.log(row.content[z].lyric);
              concatenateWord = concatenateWord + row.content[z].originalLyric.replace('-', '').replace('#', '');
              // console.log("concaténé : "+ concatenateword);
              // console.log("continueloop");
              row.content[z].originalLyric = undefined;
              row.content[z].lyric = undefined;
              row.content[lastWordDiv].duration += 1;
            }
            else {
              // console.log("break, normal text");
              break;
            }
          }
          if (i > 0) {
            row.content[i - 1].lyric = concatenateWord;
          }
          else {
            row.content[i].lyric = concatenateWord;
          }
          // console.log(
          //  "Last word, appended : " +
          //    concatenateword
          // );
        }
        else {
          lastWordDiv = i;
          row.content[i].lyric = row.content[i].lyric.replace('#', '');
          row.content[i].originalLyric = row.content[i].originalLyric.replace('#', '');
        }
      }
    }
  });

  // On nettoie les undefined qui restent

  arrayLyrics.forEach(function (row) {
    for (let i = row.content.length - 1; i >= 0; i--) {
      if (
        (typeof row.content[i].originalLyric === 'undefined' ||
          typeof row.content[i].lyric === 'undefined' ||
          row.content[i].originalLyric === '' ||
          (row.content[i].originalLyric === '-' && row.content[i].lyric === '')) &&
        typeof row.content[i].printIndex === 'undefined'
      ) {
        row.content.splice(i, 1);
      }
    }
  });

  songToProcess.processedLyrics = arrayLyrics;

  return songToProcess;
}
